module.exports = __webpack_public_path__ + "img/team-list5.dfa80e04.png";